import { ButtonMenu } from "ui/components/Button/ButtonMenu";
import ButtonMenuItem from "ui/components/Button/ButtonMenu/ButtonMenuItem";
import { Column, ColumnTypes } from "ui/components/Table/TableSearch/types";

import { CronJobExecutionEventType, CronJobExecutionRow } from "services/api/cronjobs/types";
import { formatCronDateTime, formatDuration } from "services/api/cronjobs/transformations";

import CronJobExecutionStatusBadge from "../../components/CronJobExecutionStatusBadge/CronJobExecutionStatusBadge";

export const CRON_JOB_EXECUTION_COLUMNS: Column[] = [
  {
    title: "#",
    field: "id",
    type: ColumnTypes.custom,
    render: (row: CronJobExecutionRow) => (
      <span className="font-mono text-xs text-slate-500">{row.id}</span>
    ),
  },
  {
    title: "Status",
    field: "status",
    sortable: true,
    type: ColumnTypes.custom,
    render: (row: CronJobExecutionRow) => <CronJobExecutionStatusBadge status={row.status} />,
  },
  {
    title: "Početak",
    field: "started",
    sortable: true,
    type: ColumnTypes.custom,
    render: (row: CronJobExecutionRow) => (
      <span className="text-sm text-slate-700 whitespace-nowrap">
        {formatCronDateTime(row.started)}
      </span>
    ),
  },
  {
    title: "Kraj",
    field: "finished",
    sortable: true,
    type: ColumnTypes.custom,
    render: (row: CronJobExecutionRow) => (
      <span className="text-sm text-slate-700 whitespace-nowrap">
        {formatCronDateTime(row.finished)}
      </span>
    ),
  },
  {
    title: "Trajanje",
    field: "durationSeconds",
    type: ColumnTypes.custom,
    render: (row: CronJobExecutionRow) => (
      <span className="text-sm text-slate-600 whitespace-nowrap">
        {formatDuration(row.durationSeconds)}
        {row.status === "running" && <span className="text-xs text-slate-400"> (traje)</span>}
      </span>
    ),
  },
  {
    title: "Log zapisa",
    field: "logCount",
    type: ColumnTypes.custom,
    render: (row: CronJobExecutionRow) => <span className="text-slate-600">{row.logCount}</span>,
  },
  {
    title: "",
    field: "actions",
    type: ColumnTypes.custom,
    render: (row: CronJobExecutionRow, onEventClick) => (
      <ButtonMenu endIcon="/media/icons/more-dots.svg" variant="text">
        <ButtonMenuItem
          startIcon="/media/icons/document.svg"
          onClick={() => onEventClick(String(row.id), CronJobExecutionEventType.LOGS)}
        >
          Log obrade
        </ButtonMenuItem>
      </ButtonMenu>
    ),
  },
];
